/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { currentUser } from '@auth/store/auth.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { UserRole } from '@shared/models';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';

@Injectable()
export class SuperAdminGuard {

  constructor(
    private store: Store<State>,
    private router: Router
  ) { }

  /**
   * Bewusst ueber den Store statt ueber ngx-permissions: beim direkten Aufruf der URL
   * sind die Berechtigungen noch leer, das Profil kommt erst per HTTP nach.
   */
  canActivate(): Observable<boolean> {
    return this.store.select(currentUser).pipe(
      filter(user => !!user),
      take(1),
      map(user => user.roles.includes(UserRole.SuperAdmin)),
      tap((isSuperAdmin: boolean) => {
        if (false === isSuperAdmin) {
          this.router.navigate(['/tours']);
        }
      })
    );
  }
}
